import { render, staticRenderFns } from "./BomBudgetInput.vue?vue&type=template&id=80961248&lang=pug&"
import script from "./BomBudgetInput.vue?vue&type=script&lang=ts&"
export * from "./BomBudgetInput.vue?vue&type=script&lang=ts&"
import style0 from "./BomBudgetInput.vue?vue&type=style&index=0&id=80961248&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports